module.exports = __webpack_public_path__ + "img/hooch.1665d953.png";